import { Button } from "../../../../../../shared/infrastructure";
import { OfferT } from "../../../../domain";
import toast from "react-hot-toast";
import { useDeleteOffer } from "../../../services";
import React, { useCallback } from "react";

type OfferStatusUpdateProps = {
  data: OfferT;
  close: () => void;
};

export const DeleteOfferConfirmation = ({
  data,
  close,
}: OfferStatusUpdateProps): React.ReactElement => {
  const { mutateAsync: deleteOffer, isLoading } = useDeleteOffer();

  const handleDelete = useCallback(() => {
    deleteOffer({
      offerId: data.approval_id,
    })
      .then(() => {
        toast.success("Offer Status deleted successfully");
        close();
      })
      .catch(() => {
        toast.error("Something happen deleting the offer");
        close();
      });
  }, [data.approval_id, close, deleteOffer]);

  return (
    <section className="grid gap-[20px]">
      <section className="grid gap-[4px]">
        <h1 className="text-[20px] font-[700]">Delete Offer</h1>
        <span className="text-[10px] font-[400] text-[#919191]">
          {data.type === "single"
            ? `Order No. ${data.order_number}`
            : "Dedicated"}
        </span>
      </section>
      <p className="px-[20px] text-center text-[14px]">
        Are you sure want to delete the offer{" "}
        <span className="font-[700]">{data.approval_id}</span>?
      </p>
      <section className="grid grid-flow-col justify-center gap-[20px]">
        <Button
          appearance="secondary"
          className="w-[100px]"
          type="button"
          onClick={close}
        >
          Cancel
        </Button>
        <Button
          appearance="primary"
          className="w-[100px]"
          status={isLoading ? "loading" : "default"}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </section>
    </section>
  );
};
